import { Location } from 'history'

import { removeHashFromPath } from '../../../utils/removeHashFromPath'

const noParamsRoutes = ['password_reset', 'organization-invitation', 'umbrella-invitation']

// Ember's route params are nested by route name, unlike React Router's flat params - params
// merged from both sources (see getRouteParams) can legitimately be either shape.
type RouteParamValue = string | Record<string, string> | undefined

const getIdsFromParams = (params: Record<string, RouteParamValue>) => {
  const ids: string[] = []

  for (const outerKey of Object.keys(params)) {
    const innerValue = params[outerKey]

    if (typeof innerValue === 'string') {
      ids.push(innerValue)
    } else if (innerValue && !Array.isArray(innerValue)) {
      for (const innerKey of Object.keys(innerValue)) {
        if (/^(.*)_id$/.test(innerKey)) {
          ids.push(innerValue[innerKey])
        }
      }
    }
  }

  return ids
}

export const getSimplifiedRouteNameForSegmentTracking = (
  location: Location,
  params: Record<string, RouteParamValue>,
) => {
  const route = `${location.pathname}${location.search}${removeHashFromPath(location.hash)}`

  const routeParts = route.split('/').filter(Boolean)

  if (routeParts.length) {
    if (noParamsRoutes.includes(routeParts[0])) {
      return routeParts[0]
    }

    let routeProperty = route.substring(route.indexOf('/', routeParts[0] === 'umbrellas' ? 0 : 1) + 1).split('?')[0]

    if (params) {
      const idInParams = getIdsFromParams(params)

      if (idInParams.length) {
        for (const id of idInParams) {
          routeProperty = routeProperty.replace(id, 'id')
        }
      }

      return routeProperty
    }
  }

  return 'unknown'
}
